<div class="d-flex flex-column container">
  <!-- //options  -->
  <div class="select-option-tag">
    <label class="dropdown-option">
      <label class="custom-radio">
        <input
          type="radio"
          name="user-status"
          value="option1"
          class="radio-input"
        />
        <span class="radio-mark"></span>
      </label>
      Exact Search
    </label>

    <label class="dropdown-option">
      <label class="custom-radio">
        <input
          type="radio"
          name="user-status"
          value="option1"
          class="radio-input"
        />
        <span class="radio-mark"></span>
      </label>
      Contains within
    </label>
  </div>
  <label class="dropdown-option">
    <label class="custom-radio">
      <input
        type="radio"
        name="user-status"
        value="option1"
        class="radio-input"
      />
      <span class="radio-mark"></span>
    </label>
    starts with
  </label>

  <!-- options end  -->
  <form
    (ngSubmit)="onNameSearch(true)"
    [formGroup]="nameSearchForm"
    class="mt-4"
  >
    <div class="row flex flex-column gap-4">
      <div class="search-container">
        <input
          class="search-input-mobile dp-input-control"
          type="text"
          formControlName="firstName"
          placeholder="Member First Name"
          aria-label="Search1"
        />
        <span class="search-icon">
          <img src="../../assets/images/search-dark.svg" />
        </span>
      </div>
      <div class="search-container">
        <input
          class="search-input-mobile dp-input-control"
          type="text"
          formControlName="lastName"
          placeholder="Member Last Name"
          aria-label="Search"
        />
        <span class="search-icon">
          <img src="../../assets/images/search-dark.svg" />
        </span>
      </div>

      <div class="search-container">
        <input
          class="search-input-mobile dp-input-control"
          type="text"
          formControlName="guardianFirstName"
          placeholder="Guardian First Name"
          aria-label="Search"
        />
        <span class="search-icon">
          <img src="../../assets/images/search-dark.svg" />
        </span>
      </div>

      <div class="search-container">
        <input
          class="search-input-mobile dp-input-control"
          type="text"
          formControlName="guardianLastName"
          placeholder="Guardian Last Name"
          aria-label="Search"
        />
        <span class="search-icon">
          <img src="../../assets/images/search-dark.svg" />
        </span>
      </div>
    </div>

    <div class="d-flex align-items-center btn-margin">
      <button class="dp-secondary-btn clear-btn" type="reset">
        Clear Entries
      </button>
      <button class="dp-primary-btn search-btn ms-3">Search</button>
    </div>
  </form>

  <div class="tableBoxMob mt-4">
    <div
      class="dataList dp-table-scroll"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onScroll()"
    >
      @for( lists of responseData; track lists){
      <ul class="eachdataList">
        <li class="data">
          Sl.No
          <span
            (click)="onCellClick(lists.slNo)"
            class="serial-no"
            >{{ lists.slNo }}</span
          >
        </li>
        <li class="data">
          Status<span>{{ lists.memberStatus }}</span>
        </li>
        <li class="data">
          District <span>{{ lists.district }}</span>
        </li>
        <li class="data">
          Name <span>{{ lists.fullName }}</span>
        </li>
        <li class="data">
          Guardian <span>{{ lists.guardianFullName }}</span>
        </li>
        <li class="data">
          Initiation date <span>{{ lists.initiationDate }}</span>
        </li>
        <li class="data">
          Ritwik <span>{{ lists.ritwik }}</span>
        </li>
        <li class="data">
          Address <span>{{ lists.address }}</span>
        </li>
      </ul>
      }
    </div>
  </div>
</div>
